import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'

/** Read the `role` claim out of the JWT (no external dep). */
function roleFromToken(token: string | null): string | null {
  if (!token) return null
  try {
    const payload = token.split('.')[1]
    const json = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))
    return json.role ?? null
  } catch {
    return null
  }
}

/** Only ADMIN users may see the admin panel; everyone else is bounced to the dashboard. */
export default function AdminRoute({ children }: { children: React.ReactNode }) {
  const token = useAuthStore((s) => s.accessToken)
  if (roleFromToken(token) !== 'ADMIN') return <Navigate to="/dashboard" replace />
  return <>{children}</>
}
